/**
 * Configuración del sistema de temas dinámicos.
 * Ver docs/DYNAMIC_THEME.md para documentación completa.
 */

import { ThemeName } from './types';

export const DEFAULT_THEME: ThemeName = 'FIELPET';
export const STORAGE_KEY = 'app-theme';
export const THEME_QUERY_PARAM = 'theme';

/**
 * @property dynamicThemeEnabled - true: white-label (URL/localStorage), false: usa fixedTheme
 * @property fixedTheme - Tema fijo cuando dynamicThemeEnabled es false
 */
export const THEME_CONFIG = {
  dynamicThemeEnabled: false,
  fixedTheme: DEFAULT_THEME,
} as const;

export const isDynamicThemeEnabled = THEME_CONFIG.dynamicThemeEnabled;
